import lang from '../lang'

export default {
    RECENT_TYPES: {
        1: lang.get('公告'),
        2: lang.get('活動'),
        3: lang.get('更新'),
    },
    NEWS_TYPES: {
        1: lang.get('遊戲地圖'),
        2: lang.get('新手指南'),
        3: lang.get('裝備技能'),
        4: lang.get('進階攻略'),
    },
    RECHARGE_STATUS: {
        1: lang.get('未付'),
        2: lang.get('支付中'),
        3: lang.get('已付'),
        4: lang.get('取消'),
        5: lang.get('交易失敗'),
    },
    COMMUNITY_TYPE: {
        1: lang.get('聊天'),
        2: lang.get('問題'),
        3: lang.get('建議'),
    },
    FAQ_TYPE_CHOICES: {
        1: lang.get('會員賬號'),
        2: lang.get('安裝/執行'),
        3: lang.get('儲值/購買'),
        4: lang.get('遊戲問題'),
        100: lang.get('其他')
    },
    QUESTION_TYPE_CHOICES: {
        1: lang.get('會員資料'),
        2: lang.get('遊戲使用'),
        3: lang.get('安裝/執行'),
        4: lang.get('儲值'),
        5: lang.get('運營'),
        100: lang.get('其他'),
    },
}